import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Paper } from '@mui/material';

export const LandingLayout = () => {
    const styles = {
        wrapper: {
            backgroundColor: '#E6E6EC',
            display: 'flex',
            justifyContent: 'center',
            height: '100vh',
            margin: -1,
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '1em',
        },
    };

    return (
        <Box sx={styles.wrapper}>
            <Box sx={styles.content}>
                <Paper
                    sx={{
                        p: 5,
                        width: { xs: '80vw', sm: '50vw', md: '50vw' },
                        position: 'relative',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                    }}
                >
                    <Outlet />
                </Paper>
            </Box>
        </Box>
    );
};
